// extracted by mini-css-extract-plugin
export default {"box":"box__YrE6g","background":"background__Sx0ac","header":"header__4ZjOB","input":"input__mkjDQ","button":"button__QrB2Q","button2":"button2__CoG-T"};